import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6938a8b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<nav data-v-6938a8b6><div class=\"mx-auto p-6\" data-v-6938a8b6><img src=\"" + _imports_0 + "\" alt=\"logo image\" class=\"w-24\" data-v-6938a8b6></div></nav><section class=\"mt-4\" data-v-6938a8b6><div class=\"mx-auto flex space-y-4 text-left md:text-center justify-start p-4 md:p-0 md:justify-center\" data-v-6938a8b6><h2 class=\"text-3xl md:text-6xl xl:text-7xl font-bold tracking-widest\" data-v-6938a8b6>Generate Dynamic<a class=\"text-orange-500\" data-v-6938a8b6><br data-v-6938a8b6>QR Codes </a>for any occasion.</h2></div></section>", 2)
const _hoisted_3 = { class: "mt-8 md:mt-20" }
const _hoisted_4 = { class: "mx-auto container p-4 md:p-0" }
const _hoisted_5 = { class: "flex flex-col md:flex-row space-y-6 md:space-x-12 md:space-y-0" }
const _hoisted_6 = { class: "w-full md:w-1/2 p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-md md:text-xl" }, "Enter your website URL", -1))
const _hoisted_8 = { class: "mt-8 flex flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "mt-8 self-center"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-8 self-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold mb-6 text-center" }, "Live Preview", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Right click the image to download it.", -1))
const _hoisted_13 = {
  key: 0,
  class: "w-full flex justify-between md:w-80 flex-col"
}
const _hoisted_14 = { class: "p-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-md md:text-xl" }, "Colors", -1))
const _hoisted_16 = { class: "mt-8 flex flex-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-lg" }, "Custom color", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSpinnerPie = _resolveComponent("VueSpinnerPie")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getCode && _ctx.getCode(...args)), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "url",
                  class: "border form-input border-darkOrange w-full text-xl md:text-2xl p-2 rounded-lg",
                  placeholder: "Enter your website URL",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.url) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.url]
                ])
              ], 32),
              (_ctx.showSpinner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_VueSpinnerPie, {
                      size: "300",
                      color: "#f46530"
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode(_component_qrcode_vue, {
                      value: _ctx.value,
                      size: _ctx.size,
                      level: "H",
                      foreground: _ctx.foreground
                    }, null, 8, ["value", "size", "foreground"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      id: "#000000",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-black",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#FF0000",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-red",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#A020F0",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-purple",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#4B0082",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-indigo",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#FFDB58",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-mustard",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#FFC0CB",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-pink",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#00FF00",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-green",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#964B00",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-brown",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#0000FF",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-blue",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#FFD700",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-yellowGold",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#87ceeb",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-skyBlue",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#A7226E",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-purpleUnique",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#F7DB4F",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-redUnique",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#F26B38",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-orangeUnique",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#EC2049",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-yellowUnique",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    }),
                    _createElementVNode("a", {
                      id: "#2F9599",
                      class: "border colors active:border-darkOrange rounded-md h-10 w-10 flex justify-center items-center rounded-md bg-tealUnique",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changeColor && _ctx.changeColor(...args)))
                    })
                  ]),
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "color",
                    class: "h-10 w-10 rounded-md mt-2",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customColor) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.customColor]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}